export const FEEDBACK_PAGE_SIZE = 5;

export const EMPLOYEE_REVIEW_RATING_FIELDS = new Set([
  'teamwork',
  'communication',
  'helpfulness',
  'reliability',
  'professionallevel',
]);
